import { requestApi } from '../util/network'

export const getClassTree =
() =>
  requestApi(
    '/o2o_fuwu_class/get_class_tree',
    'POST',
    {
    }
  )

